import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-whatsapp-chat',
  templateUrl: './whatsapp-chat.component.html',
  styleUrls: ['./whatsapp-chat.component.css']
})
export class WhatsappChatComponent implements OnInit {

  isChatOpen = false;
  message = '';
  chatMessages: Array<{ text: string, from: string, time: string, link?: string }> = [];
  isFirstOpen = true; // Controla si es la primera vez que se abre el chat
  
  // Número de WhatsApp de Mier y Terán (configura aquí tu número con código de país sin +)
  // Ejemplo: 5215512345678 (52 = México, 55 = CDMX, resto = número)
  whatsappNumber = '529992804139'; // CAMBIA ESTE NÚMERO

  constructor() { }

  ngOnInit() {
    // Mensaje de bienvenida fijo desde que carga la página
    this.chatMessages.push({
      text: '¡Hola! 👋 Somos Mier y Terán - Expertos en comercio exterior 🌎',
      from: 'support',
      time: this.getCurrentTime()
    });
  }

  toggleChat() {
    this.isChatOpen = !this.isChatOpen;
    
    // Si es la primera vez que se abre, mostrar mensajes progresivos
    if (this.isChatOpen && this.isFirstOpen) {
      this.isFirstOpen = false;
      this.showProgressiveMessages();
    }
  }

  showProgressiveMessages() {
    // Diferenciador + autoridad (reforma aduanera)
    setTimeout(() => {
      this.chatMessages.push({
        text: 'Estamos actualizados con la nueva reforma aduanera. 😎',
        from: 'support',
        time: this.getCurrentTime()
      });
    }, 800);

    // Pregunta única y poderosa (aplica a todos)
    setTimeout(() => {
      this.chatMessages.push({
        text: '¿Qué necesitas hoy? Importar, exportar o asesoría? 📦✈️',
        from: 'support',
        time: this.getCurrentTime()
      });
    }, 2000);

    // CTA ultra-directo con beneficio inmediato
    setTimeout(() => {
      this.chatMessages.push({
        text: 'Escríbenos ahora. Te respondemos rápido. ⚡',
        from: 'support',
        time: this.getCurrentTime()
      });
    }, 3000);
  }

  sendMessage() {
    if (this.message.trim() === '') {
      return;
    }

    // Agregar mensaje del usuario al chat visual
    this.chatMessages.push({
      text: this.message,
      from: 'user',
      time: this.getCurrentTime()
    });

    // Log del mensaje en consola
    console.log('Mensaje enviado:', this.message);

    // Crear URL de WhatsApp con el mensaje
    const mensajeCodificado = encodeURIComponent(this.message);
    const whatsappUrl = `https://wa.me/${this.whatsappNumber}?text=${mensajeCodificado}`;
    
    // Abrir WhatsApp en una nueva ventana/pestaña
    window.open(whatsappUrl, '_blank');

    // Mostrar mensaje de confirmación con enlace
    setTimeout(() => {
      this.chatMessages.push({
        text: '✓ Se abrió WhatsApp. Si no se abrió, haz clic aquí →',
        from: 'support',
        time: this.getCurrentTime(),
        link: whatsappUrl
      });
    }, 500);

    // Limpiar input
    this.message = '';
  }

  openWhatsAppLink(url: string) {
    if (url) {
      window.open(url, '_blank');
    }
  }

  getCurrentTime(): string {
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  onKeyPress(event: KeyboardEvent) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.sendMessage();
    }
  }
}
